import { Label } from "@ui/label";
import { Toggle } from "@ui/toggle";
import { ValidationError } from "@/components/ui/validation-error";
import type { RowExpressionHeaderType } from "./types";
import CodeEditButton from "@ui/button/code-edit-button";
import { ExpressionDefault, ExpressionType } from "@/const/expression";

export function RowExpressionHeaderFields({
  header,
  updateHeader,
  headerError,
}: RowExpressionHeaderType) {
  const isHidden = (header.hide as boolean) ?? false;

  return (
    <>
      <>
        <div>
          <Label>Expression</Label>
          <CodeEditButton
            variant="validation"
            onSave={(code) => {
              updateHeader({ expression: code });
            }}
            validationReturnType={["any"]}
            isApi={true}
            showApiToggle={false}
            value={
              header.expression ?? ExpressionDefault[ExpressionType.GridRow]
            }
            trigger={header.expression}
          />
        </div>
        {headerError && <ValidationError>{headerError}</ValidationError>}
      </>
      <div className="flex flex-row justify-between items-center">
        <span className="text-base font-medium text-dark">Show component</span>
        <Toggle
          pressed={!isHidden}
          onPressedChange={(pressed) => updateHeader({ hide: !pressed })}
        />
      </div>
    </>
  );
}
